// extracted by mini-css-extract-plugin
export default {"frame":"Plugin_frame__LwFcq"};